import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';
import { loginService } from '@/services/login.service';

@Mixin
export default class AuthValidationMixin extends Vue {
  public static loginPageUrl = process.env.VUE_APP_LOGIN_PAGE_URL || '/'
  async created(): Promise<void> {
    const loggedIn: boolean = await loginService.isLoggedn();
    console.log('**********loggedIn******',loggedIn);
    // GS-900: only auth pages mix this in, and each requires login; the page context is the PREVIOUS page's here
    if (!loggedIn && this.$router) {
      console.log('**********loggedIn*2*****',AuthValidationMixin.loginPageUrl);
      window.location.href = AuthValidationMixin.loginPageUrl;
    }
  }
}
